// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   PRIMARY STYLES
   Critical styles that load before theme system
   Contains LoginPopup and essential pre-auth UI
   ============================================ */

/* ============================================
   ESSENTIAL VARIABLES
   Minimal variables needed for pre-auth UI
   ============================================ */

:root {
  /* Typography */
  --font-family-base: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

  /* Colors */
  --color-near-black: #1a1a1a;
  --color-charcoal: #2f2f2f;
  --color-gray-medium: #666;
  --color-gray-light: #e0e0e0;
  --color-gray-lighter: #f5f5f5;

  /* Overlays */
  --overlay-black-80: rgba(0, 0, 0, 0.8);
  --overlay-white-30: rgba(255, 255, 255, 0.3);

  /* Shadows */
  --shadow-login: 0 4px 12px rgba(0, 0, 0, 0.15);

  /* Border Radius */
  --radius-xl: 16px;
  --radius-md: 8px;
  --radius-full: 50%;

  /* Z-Index */
  --z-modal: 1000;

  /* Transitions */
  --transition-fast: 0.2s;
}

/* ============================================
   GLOBAL RESET
   ============================================ */

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  font-family: var(--font-family-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ============================================
   SHARED ANIMATIONS
   ============================================ */

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes login-slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ============================================
   LOGIN POPUP
   ============================================ */

.login-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--overlay-black-80);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal)0;
  animation: fadeIn 0.3s ease-out;
}

.login-popup {
  background: white;
  border-radius: var(--radius-xl);
  padding: 48px 64px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: login-slideUp 0.4s ease-out;
}

.login-popup-content {
  text-align: center;
}

.login-popup-content h1 {
  margin: 0 0 16px 0;
  font-size: 32px;
  color: var(--color-near-black);
  font-weight: 700;
}

.login-popup-content p {
  margin: 0 0 24px 0;
  font-size: 18px;
  color: var(--color-gray-medium);
  line-height: 1.6;
}

.email-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid var(--color-gray-light);
  border-radius: var(--radius-md);
  margin-bottom: 20px;
  transition: border-color var(--transition-fast) ease;
  box-sizing: border-box;
}

.email-input:focus {
  outline: none;
  border-color: var(--color-charcoal);
}

.email-input:disabled {
  background-color: var(--color-gray-lighter);
  cursor: not-allowed;
}

.login-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background: var(--color-charcoal);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast) ease;
  box-shadow: var(--shadow-login);
}

.login-button:hover {
  background: var(--color-near-black);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.login-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.login-button:disabled:hover {
  background: var(--color-charcoal);
  transform: none;
  box-shadow: var(--shadow-login);
}

.microsoft-icon {
  width: 20px;
  height: 20px;
}

.login-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid var(--overlay-white-30);
  border-top-color: white;
  border-radius: var(--radius-full);
  animation: spin 0.8s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/styles/primary.css"],"names":[],"mappings":"AAAA;;;;iDAIiD;;AAEjD;;;iDAGiD;;AAEjD;EACE,eAAe;EACf,qKAAqK;;EAErK,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;;EAE7B,aAAa;EACb,sCAAsC;EACtC,4CAA4C;;EAE5C,YAAY;EACZ,8CAA8C;;EAE9C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;EAElB,YAAY;EACZ,eAAe;;EAEf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,+BAA+B;EAC/B,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,iCAAiC;EACjC,oCAAoC;AACtC","sourcesContent":["/* ============================================\r\n   PRIMARY STYLES\r\n   Critical styles that load before theme system\r\n   Contains LoginPopup and essential pre-auth UI\r\n   ============================================ */\r\n\r\n/* ============================================\r\n   ESSENTIAL VARIABLES\r\n   Minimal variables needed for pre-auth UI\r\n   ============================================ */\r\n\r\n:root {\r\n  /* Typography */\r\n  --font-family-base: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\r\n\r\n  /* Colors */\r\n  --color-near-black: #1a1a1a;\r\n  --color-charcoal: #2f2f2f;\r\n  --color-gray-medium: #666;\r\n  --color-gray-light: #e0e0e0;\r\n  --color-gray-lighter: #f5f5f5;\r\n\r\n  /* Overlays */\r\n  --overlay-black-80: rgba(0, 0, 0, 0.8);\r\n  --overlay-white-30: rgba(255, 255, 255, 0.3);\r\n\r\n  /* Shadows */\r\n  --shadow-login: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n\r\n  /* Border Radius */\r\n  --radius-xl: 16px;\r\n  --radius-md: 8px;\r\n  --radius-full: 50%;\r\n\r\n  /* Z-Index */\r\n  --z-modal: 1000;\r\n\r\n  /* Transitions */\r\n  --transition-fast: 0.2s;\r\n}\r\n\r\n/* ============================================\r\n   GLOBAL RESET\r\n   ============================================ */\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: var(--font-family-base);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* ============================================\r\n   SHARED ANIMATIONS\r\n   ============================================ */\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes login-slideUp {\r\n  from {\r\n    transform: translateY(30px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   LOGIN POPUP\r\n   ============================================ */\r\n\r\n.login-popup-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--overlay-black-80);\r\n  backdrop-filter: blur(8px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: var(--z-modal)0;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.login-popup {\r\n  background: white;\r\n  border-radius: var(--radius-xl);\r\n  padding: 48px 64px;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  animation: login-slideUp 0.4s ease-out;\r\n}\r\n\r\n.login-popup-content {\r\n  text-align: center;\r\n}\r\n\r\n.login-popup-content h1 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 32px;\r\n  color: var(--color-near-black);\r\n  font-weight: 700;\r\n}\r\n\r\n.login-popup-content p {\r\n  margin: 0 0 24px 0;\r\n  font-size: 18px;\r\n  color: var(--color-gray-medium);\r\n  line-height: 1.6;\r\n}\r\n\r\n.email-input {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  font-size: 16px;\r\n  border: 2px solid var(--color-gray-light);\r\n  border-radius: var(--radius-md);\r\n  margin-bottom: 20px;\r\n  transition: border-color var(--transition-fast) ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.email-input:focus {\r\n  outline: none;\r\n  border-color: var(--color-charcoal);\r\n}\r\n\r\n.email-input:disabled {\r\n  background-color: var(--color-gray-lighter);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 14px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: white;\r\n  background: var(--color-charcoal);\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  cursor: pointer;\r\n  transition: all var(--transition-fast) ease;\r\n  box-shadow: var(--shadow-login);\r\n}\r\n\r\n.login-button:hover {\r\n  background: var(--color-near-black);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.login-button:active {\r\n  transform: translateY(0);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.login-button:disabled {\r\n  opacity: 0.7;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.login-button:disabled:hover {\r\n  background: var(--color-charcoal);\r\n  transform: none;\r\n  box-shadow: var(--shadow-login);\r\n}\r\n\r\n.microsoft-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.login-spinner {\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 3px solid var(--overlay-white-30);\r\n  border-top-color: white;\r\n  border-radius: var(--radius-full);\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
